import { SubmissionTableLabColumnKey } from './submission-table-lab.models';

export type SubmissionTableLabHeaderKey = SubmissionTableLabColumnKey | 'action';

type HeaderSize = {
  width: number;
  minWidth: number;
  maxWidth: number;
};

export const SUBMISSION_TABLE_LAB_HEADER_SIZES: Record<SubmissionTableLabHeaderKey, HeaderSize> = {
  action: { width: 88, minWidth: 88, maxWidth: 88 },
  submissionStatus: { width: 140, minWidth: 140, maxWidth: 180 },
  evaluationStatus: { width: 170, minWidth: 170, maxWidth: 220 },
  id: { width: 110, minWidth: 110, maxWidth: 140 },
  submitDate: { width: 150, minWidth: 150, maxWidth: 200 },
  insured: { width: 280, minWidth: 220, maxWidth: 360 },
  underwriter: { width: 170, minWidth: 170, maxWidth: 240 },
  quoteId: { width: 140, minWidth: 140, maxWidth: 190 },
  applicationType: { width: 140, minWidth: 140, maxWidth: 200 },
  policyNumber: { width: 140, minWidth: 140, maxWidth: 200 },
  line: { width: 140, minWidth: 140, maxWidth: 220 },
  submissionType: { width: 150, minWidth: 150, maxWidth: 220 },
  riskAppetite: { width: 130, minWidth: 130, maxWidth: 170 },
  bindPropensity: { width: 130, minWidth: 130, maxWidth: 170 },
  dataQualityScore: { width: 130, minWidth: 130, maxWidth: 170 },
  effectiveDate: { width: 150, minWidth: 150, maxWidth: 200 },
  annualRevenue: { width: 150, minWidth: 150, maxWidth: 220 }
};

export function createSubmissionTableLabHeaderWidths(): Record<SubmissionTableLabHeaderKey, number> {
  return Object.fromEntries(
    Object.entries(SUBMISSION_TABLE_LAB_HEADER_SIZES).map(([key, size]) => [key, size.width])
  ) as Record<SubmissionTableLabHeaderKey, number>;
}

export function clampSubmissionTableLabHeaderWidth(key: SubmissionTableLabHeaderKey, width: number): number {
  const size = SUBMISSION_TABLE_LAB_HEADER_SIZES[key];
  return Math.min(size.maxWidth, Math.max(size.minWidth, width));
}
